import { render } from "./ArticleLink.vue?vue&type=template&id=49063fab&scoped=true"
import script from "./ArticleLink.vue?vue&type=script&lang=js"
export * from "./ArticleLink.vue?vue&type=script&lang=js"

import "./ArticleLink.vue?vue&type=style&index=0&id=49063fab&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49063fab"]])

export default __exports__